import {InjectionToken} from '@angular/core';
import type {Observable} from 'rxjs';
import type {ContactEvent, ContactsListResult, EventMembersListQuery} from '../types/contacts.types';

export interface EventMembersApi {
  listContactsInEvent(query: EventMembersListQuery): Observable<ContactsListResult>;
  addMembersManual(
    eventId: string,
    items: {mobile: string; raiseDateTime?: number | null}[],
  ): Observable<void>;
  addMembersByFile(eventId: string, file: File): Observable<void>;
  addMembersByContactIds(
    eventId: string,
    contactIds: string[],
    raiseDateTime?: number | null,
  ): Observable<void>;
  updateMemberEventDate(eventId: string, contactId: string, eventDate: string): Observable<void>;
  removeContactFromEvent(eventId: string, contactId: string, deleteGlobally: boolean): Observable<void>;
  seedMembersForEvents(events: ContactEvent[]): void;
  getMemberCount(eventId: string): number;
}

export const EVENT_MEMBERS_API = new InjectionToken<EventMembersApi>('EVENT_MEMBERS_API');
